import React from "react"
import uuid from "uuid"
import styled from "styled-components"
import isEmpty from "lodash/isEmpty"
import { connect } from "react-redux"
import Divider from "@material-ui/core/Divider"
import { withRouter } from "react-router"
import { KeyboardArrowRight } from "@material-ui/icons"
import Storage from "../../util/Storage"

import Cookie from "../../util/Cookie"
import { fetchData, removeData } from "../../store/action"
import config from "../../Config"
import { event } from "../../components/reactGA"
import EditInfoForm from "./EditInfoForm"
import i18n from "../../i18n"

const Container = styled.div`
  height: calc(100% - 56px);
  box-sizing: border-box;
  overflow-y: auto;
`

// const Row = styled.div`
//   padding: 20px;
// `

// const Label = styled.div`
//   margin-bottom: 10px;
//   font-size: 12px;
//   color: gray;
// `

// const Value = styled.div`
//   font-size: 18px;
// `

const UnSub = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  padding-right: 5px;
  padding-left: 5px;
  color: #fb0e56;
`

// const TNC = styled.a`
//   text-decoration: none;
//   color: #2ebaaa;
// `

const InnerContainer = styled.div`
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
`
const UpperBox = styled.div`
  width: 100%;
  border-radius: 8px;
  height: 120px;
  display: flex;
`
const LeftUpperBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`

const Circle = styled.div`
  width: 70px;
  height: 70px;
  background-color: #1c1d23;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const RightUpperBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`

const UserName = styled.p`
  font-size: 16px;
  font-family: "montserratLight";
  color: #fff;
  font-weight: 600;
`
const ButtonWrapper = styled.div`
  display: flex;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
`

const EditButton = styled.button`
  width: 81px;
  height: 36px;
  background-color: #1c1d23;
  color: #fb0e56;
  font-family: "montserratLight";
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 19px;
  border: none;
  outline: none;
  cursor: pointer;
`

const List = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
`

const ListLeft = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`

const ListText = styled.span`
  font-family: "montserratLight";
  color: #fff;
  font-size: 16px;
`

const ListTextSec = styled.span`
  font-family: "montserratLight";
  color: #fff;
  font-size: 14px;
  opacity: 0.5;
  margin-left: 15px;
`

const ListRightIcon = styled.span`
  color: #fff;
  cursor: pointer;
`
const SuccessIcon = styled.span`
  margin-right: 15px;
  margin-top: 3px;
`
const LogoutButton = styled.button`
  width: 75%;
  height: 56px;
  padding: 19px 60px 18px;
  border-radius: 30px;
  border: solid 1px #fb0e56;
  box-sizing: border-box;
  color: #fb0e56;
  background: transparent;
  font-family: "montserratLight";
  font-weight: 600;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: auto;
`

// const AccountDetailsConfig = [
//   { label: "MobileNumber", k1: "mobile" },
//   { label: "Operator", k1: "operator" },
//   { label: "Status", k1: undefined },
//   { label: "BidsAvailable", k1: "bidBalance", k2: "Bids" },
//   { label: "BidsExpiry", k1: "expireBidCount", k2: "BidsExpiryMsg" },
// ]

class AllInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitBtnStatus: false,
      name: "",
      email: "",
      contactNumber: "",
      shippingAddress: "",
      // bidBalance: 0,
      // expireBidCount: 0,
    }
    this.loadData = this.loadData.bind(this)
    this.userProfileData = this.userProfileData.bind(this)
  }

  componentWillMount() {
    this.loadData()
  }

  componentDidMount() {}

  componentWillUnmount() {
    const { removeData, uniqueId } = this.props
    removeData({
      uniqueId,
    })
  }

  userProfileData() {
    const { fetchData, uniqueId } = this.props

    fetchData({
      uniqueId,
      noLoading: true,
      method: "GET",
      uri: `/userProfile`,
      onSuccess: (freshUser) => {
        if (!freshUser.contactNumber) {
          const userId = Cookie.get("X-Reycreo-Id")
          const msisdn = userId.split("BW_PH")
          freshUser.contactNumber = !isEmpty(msisdn[1]) && msisdn[1]
        }
        this.setState({ ...freshUser })
        Storage.set("userImage", freshUser.imageUrl)
      },
    })
  }

  loadData() {
    const { fetchData, uniqueId } = this.props
    console.log("unq", uniqueId)
    const userId = Cookie.get("X-Reycreo-Id")
    const operatorId = Cookie.get("X-Reycreo-Operator-Id")
    if (userId && operatorId) {
      const msisdn = userId.split("BW_PH")
      fetchData({
        uniqueId,
        method: "GET",
        uri: `/myAccount`,
        params: {
          msisdn: !isEmpty(msisdn) && msisdn[1],
          operatorId: operatorId,
        },
        // onSuccess: (accountInfo) => {
        //   console.log("accountInfo", accountInfo)
        //   this.setState({
        //     bidBalance: accountInfo.bidBalance,
        //     expireBidCount: accountInfo.expireBidCount,
        //   })
        // },
      })
    } else {
      console.error("Unable to fetch due to lack of informations")
    }
    this.userProfileData()
  }

  render() {
    console.log("this.state", this.state)
    console.log("unq3", this.props.uniqueId)
    const { data, t, edit, onEditClick, theme, history } = this.props
    const {
      name,
      contactNumber,
      shippingAddress,
      email,
      imageUrl,
      submitBtnStatus,
      invalidEmail,
    } = this.state

    console.log("dataAcc", data)
    if (!data) {
      return null
    } else if (data.error) {
      return <span>{data.error}</span>
    }

    let { bidBalance, expireBidCount, status } = data.data
    if (!status) {
      status = "TRIAL"
    }

    const unsubscribed = status === "UNSUBSCRIBED" || status === "TRIAL"
    return (
      <Container style={{ backgroundColor: theme.secondaryColor }}>
        <InnerContainer>
          {edit ? (
            <EditInfoForm t={t} userData={this.userProfileData} />
          ) : (
            <React.Fragment>
              <UpperBox style={{ backgroundColor: theme.cardColor }}>
                <LeftUpperBox>
                  <Circle>
                    <img
                      src={
                        localStorage.getItem("userImage")
                          ? JSON.parse(localStorage.getItem("userImage"))
                          : `${
                              config.BIDNWIN_S3_IMAGE_URL_NEW_UI
                            }/other-icons/profile.webp`
                      }
                      style={
                        localStorage.getItem("userImage") && {
                          width: "70px",
                          height: "70px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }
                      }
                    />
                  </Circle>
                </LeftUpperBox>
                <RightUpperBox>
                  <UserName>{name && name}</UserName>
                  <ButtonWrapper>
                    <EditButton onClick={onEditClick}>
                      {i18n.t("Edit")}
                    </EditButton>
                  </ButtonWrapper>
                </RightUpperBox>
              </UpperBox>

              <ul
                style={{
                  listStyleType: "none",
                  padding: "20px",
                }}
              >
                {/* <List style={{ cursor: "pointer" }}>
                  <ListText>{i18n.t("MyWinnings")}</ListText>
                  <ListRightIcon>
                    <KeyboardArrowRight />
                  </ListRightIcon>
                </List> */}
                <List
                  onClick={() => history.push(`/play/my-bids`)}
                  style={{ cursor: "pointer" }}
                >
                  <ListText>{i18n.t("MyBids")}</ListText>
                  <ListRightIcon>
                    <KeyboardArrowRight />
                  </ListRightIcon>
                </List>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <ListText>
                    {i18n.t("BidBalance")}&nbsp;
                    <ListTextSec>{bidBalance}</ListTextSec>
                  </ListText>

                  <br />
                  <ListText>
                    {i18n.t("ExpiredBidCount")}&nbsp;
                    <ListTextSec>{expireBidCount}</ListTextSec>
                  </ListText>
                </div>
                <Divider
                  style={{ backgroundColor: theme.cardColor, margin: "25px 0" }}
                />
                <List>
                  <ListLeft>
                    <SuccessIcon>
                      <img
                        src={`${
                          config.BIDNWIN_S3_IMAGE_URL_NEW_UI
                        }/other-icons/success.webp`}
                        style={{ width: "24px", height: "24px" }}
                      />
                    </SuccessIcon>
                    <ListText>{i18n.t("DeliveryAddress")}</ListText>
                  </ListLeft>
                  {/* <ListRightIcon>
                    <KeyboardArrowRight />
                  </ListRightIcon> */}
                </List>
                <List>
                  <ListLeft>
                    <SuccessIcon>
                      <img
                        src={`${
                          config.BIDNWIN_S3_IMAGE_URL_NEW_UI
                        }/other-icons/success.webp`}
                        style={{ width: "24px", height: "24px" }}
                      />
                    </SuccessIcon>
                    <ListText>{i18n.t("MobileNumber")}</ListText>
                    <ListTextSec>{data.data.mobile}</ListTextSec>
                  </ListLeft>
                  {/* <ListRightIcon>
                    <KeyboardArrowRight />
                  </ListRightIcon> */}
                </List>
                <List>
                  <ListLeft>
                    <SuccessIcon>
                      <img
                        src={`${
                          config.BIDNWIN_S3_IMAGE_URL_NEW_UI
                        }/other-icons/success.webp`}
                        style={{ width: "24px", height: "24px" }}
                      />
                    </SuccessIcon>
                    <ListText>{i18n.t("Email")}</ListText>
                    <ListTextSec>{email && email}</ListTextSec>
                  </ListLeft>
                  {/* <ListRightIcon>
                    <KeyboardArrowRight />
                  </ListRightIcon> */}
                </List>
              </ul>
              <LogoutButton
                onClick={() => {
                  Storage.clearAll()
                  window.location.href = `${config.NETWORK_URL}` + "/logout"
                }}
              >
                {i18n.t("Logout")}
              </LogoutButton>
            </React.Fragment>
          )}

          {/* {AccountDetailsConfig.map((el, index) => {
          return (
            <Row key={index}>
              <Label className='montserratLight'>{t(el.label)}</Label>
              <Value className='montserratRegular'>
                {el.k1 ? data.data[el.k1] : t(status)} {el.k2 && t(el.k2)}
              </Value>
            </Row>
          )
        })}
        <Divider /> */}
          <UnSub className='montserratLight'>
            {/* <span
            onClick={() => {
              this.props.history.push("/play/terms-and-conditions")
              event({
                category: "AccountInfo",
                action: "tnc",
              })
            }}
          >
            <TNC>{t("termsAndConditions")}</TNC>
          </span> */}

            {/*<TNC href="/terms-and-conditions" >
                    {t("termsAndConditions")}
                </TNC>*/}
            {!unsubscribed && (
              <span
                className='pointer'
                onClick={() => {
                  window.location.href = `${
                    config.BILLING_URL
                  }/billing/unsubscribe`
                  event({
                    category: "My Account Page",
                    action: "Unsubscribe",
                  })
                  // window.location.replace(`${config.BILLING_URL}/billing/unsubscribe`)
                }}
              >
                {t("UNSUBSCRIBE")}
              </span>
            )}
          </UnSub>
        </InnerContainer>
      </Container>
    )
  }
}

AllInfo = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      ;(mapStateToProps.data = state.data[ownProps.uniqueId]),
        (mapStateToProps.theme = state.theme)
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
  }
)(withRouter(AllInfo))

export default class AllInfoWrapper extends React.Component {
  componentWillMount() {
    this.uuid = uuid.v4()
  }

  render() {
    return <AllInfo {...this.props} uniqueId={this.uuid} />
  }
}



// WEBPACK FOOTER //
// ./src/views/MyAccount/AllInfo.js